<ion-button (click)="openBlocks()" [userTour]="userTour" [ariaLabel]="'core.block.opendrawerblocks' | translate" color="secondary">
    <ion-icon name="fas-chevron-left" slot="icon-only" aria-hidden="true" />
</ion-button>
